import Container from '@material-ui/core/Container'
import AppBar from 'organization/user/Layout/AppBar'
import React from 'react'

export default function Layout(props: {children: React.ReactElement}) {
  return (
    <>
      <AppBar />
      <Container maxWidth={false}>{props.children}</Container>
    </>
  )
}
